import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/3f757860/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import { StructuredListWrapper, StructuredListHead, StructuredListBody, StructuredListRow, StructuredListInput, StructuredListCell, OrderedList, ListItem } from 'carbon-components-react';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`The content switcher React Carbon component has been tested against the latest
`}<a parentName="p" {...{
          "href": "https://www.w3.org/TR/WCAG21/"
        }}>{`W3C Web Content Accessibility Guidelines (WCAG) 2.1 Level A and AA success
criteria`}</a>{` and violations have been identified
as high priority issues. This document will be updated when these
accessibility issues are resolved.`}</p>
    </PageDescription>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Accessibility considerations</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Resources</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Accessibility testing</AnchorLink>
    </AnchorLinks>
    <h2>{`Accessibility considerations`}</h2>
    <ol>
      <li parentName="ol">{`Each content switcher tab must have a unique title that clearly describes the content panel. This is particularly helpful for users of assistive technologies so they have the necessary information to efficiently navigate the content.`}</li>
      <li parentName="ol">{`Carbon components should be used to create the content that displays within each content panel.`}</li>
      <li parentName="ol">{`Content authors need to ensure the content that is added to the tab panel is accessible. For example, if you add an image to the panel you need to include alternative text to pass accessibility testing.`}</li>
    </ol>
    <h2>{`Resources`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://www.w3.org/TR/wai-aria-practices-1.1/#tabpanel"
          }}>{`W3C WAI-ARIA Tab Design Pattern`}</a>{` covers the usage of ARIA names, state and roles, as well as the expected keyboard intractions.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://www.ibm.com/able/guidelines/ci162/accessibility_checklist.html"
          }}>{`IBM Accessibility Checklist Checkpoint`}</a>{`:`}</p>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://www.ibm.com/able/guidelines/ci162/info_and_relationships.html"
            }}>{`1.3.1 Info and Relationships`}</a>{` (WCAG Success Criteria `}<a parentName="li" {...{
              "href": "https://www.w3.org/WAI/WCAG21/Understanding/info-and-relationships"
            }}>{`1.3.1`}</a>{`)`}</li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://www.ibm.com/able/guidelines/ci162/meaningful_sequence.html"
            }}>{`1.3.2 Meaningful Sequence`}</a>{` (WCAG Success Criteria `}<a parentName="li" {...{
              "href": "https://www.w3.org/WAI/WCAG21/Understanding/meaningful-sequence"
            }}>{`1.3.2`}</a>{`)`}</li>
        </ul>
      </li>
    </ul>
    <h2>{`Accessibility testing`}</h2>
    <p>{`Automated, manual and screen reader accessibility verification test has been performed on the Tabs React Carbon Component. `}<a parentName="p" {...{
        "href": "https://www.w3.org/TR/WCAG21/"
      }}>{`WCAG 2.1 Level A and AA success criteria`}</a>{` issues have been identified and the list of open accessibility violations is available in the Carbon Component GitHub repository.`}</p>
    <h3>{`Automated test`}</h3>
    <Row mdxType="Row">
  <Column noGutterSm mdxType="Column">
    <StructuredListWrapper mdxType="StructuredListWrapper">
      <StructuredListHead mdxType="StructuredListHead">
        <StructuredListRow head mdxType="StructuredListRow">
          <StructuredListCell head mdxType="StructuredListCell">
            Automated test environment
          </StructuredListCell>
          <StructuredListCell head mdxType="StructuredListCell">Results</StructuredListCell>
        </StructuredListRow>
      </StructuredListHead>
      <StructuredListBody mdxType="StructuredListBody">
        <StructuredListRow mdxType="StructuredListRow">
          <StructuredListCell mdxType="StructuredListCell">
            - macOS Mojave version 10.14.2 with VoiceOver
            <br />
            - Chrome version 77.0.3865.90
            <br />
            - Dynamic Assessment Plugin (DAP) version 1.8.0.0 - IBM
            Accessibility WCAG 2.1 Sept. 2019 Ruleset
            <br />- Carbon React version 7.7.1
          </StructuredListCell>
          <StructuredListCell mdxType="StructuredListCell">
            <strong>DAP test:</strong>
            <br />- Violations
          </StructuredListCell>
        </StructuredListRow>
      </StructuredListBody>
    </StructuredListWrapper>
  </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      